<template>
    <div class="GreOrder">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>그레 상품 주문하기</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_close.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <div class="mrg-top-15 mrg-btm-10 pdd-horizon-20 text-center">
                <img :src="data.strImageLink" width="100%" @load="imgLoad" />
                <h6 class="mrg-top-15">{{ data.strProductName }}</h6>
                <h4 class="mrg-top-10" style="color: #0086ff; font-size: 18px;">{{ data.nGreSalePrice }}그레</h4>

                <div class="gre-expected-date mrg-top-15">
                    <div class="gre-expected-point-date">
                        <h3>판매기간</h3>
                        <h4>{{ data.strStartDate }} ~ {{ data.strEndDate }}</h4>
                    </div>
                </div>

                <div class="gre-expected-date" style="border-top: none">
                    <div class="gre-expected-point-date">
                        <h3>상품발송</h3>
                        <h4 style="color: #0086ff;">{{ data.strDeliveryComment }}</h4>
                    </div>
                </div>

                <p class="mrg-top-15" v-html="data.strProductNotice"></p>
                <button class="btn-order" @click="greOrder()">상품 주문하기</button>
            </div>

        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
export default {
    name: 'GreOrder',
    props:['data'],
    data() {
        return {
        }
    },
    // 감시자
    watch: {
    },
    // $el 생성전
    created(){

    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 그레 상품 주문하기
        greOrder(){
            let formData = new FormData();
            this.ajaxPostAuth('/api/v1/gre/order/'+this.data.nProductNum, formData,this.greOrderResult);
        },
        // 그레 상품 주문하기 결과
        greOrderResult(response) {
            this.toastMsg(response.result.resultNoti.message,1500);
            this.slidePanelClose();
        }

    }
}
</script>
<style scoped>

    .gre-expected-date {border-top: 1px solid #dfdfdf;border-bottom: 1px solid #dfdfdf;padding: 10px 0px 10px 0px;}
    .gre-expected-point-date{flex: 1;display: flex;flex-direction: row;}
    .gre-expected-point-date h3{flex-basis: 80px;font-size: 15px;color: #000;line-height: 180%; text-align: left; padding-left: 10px}
    .gre-expected-point-date h4{flex: 1;text-align: right;color: #000;font-size: 15px;text-align: left;font-weight: 300}
    .gre-expected-date p{color: #a4a4a4;}

    .btn-order {
        background-color: #0086ff;
        color: #fff;
        text-align: center;
        padding: 0 15px;
        font-size: 17px;
        display: inline-block;
        height: 50px;
        line-height: 50px;
        width: 100%;
        border-radius: 10px;
        margin-top: 20px;
    }

</style>
